import { Component, OnInit, Input,isDevMode } from '@angular/core';
import { FormInfoService } from '../../../services/form-info.service';

@Component({
    selector: 'an-instigator-tile',
    templateUrl: './instigator-tile.component.html',
    styleUrls: ['./instigator-tile.component.scss'],
    standalone: false
})
export class InstigatorComponent implements OnInit {

  constructor(private formInfoService: FormInfoService) { }
  @Input('stateData')
  stateData: any;
  @Input('isInstigator')
  isInstigator: any;
  @Input('isFav')
  isFav
  title: string;
  subTitle: string;
  buttonText: string;
  url: string;
  ngOnInit() {
    this.pageLoad();
  }

  pageLoad() {
    if (this.isInstigator) {
      this.title = this.stateData.Instigator_Title;
      this.subTitle = this.stateData.Instigator_SubTitle;
      this.buttonText = this.stateData.Instigator_Button;
    }
    if (this.isFav) {
      this.title = this.stateData.NoSavedCar_Title;
      this.subTitle = this.stateData.NoSavedCar_SubTitle;
      this.buttonText = this.stateData.NoSavedCar_ShopNow;
    }
    this.url = this.stateData.carsforsale;
  }
  carsForSaleLinkUrl() {
      return this.url;
  }

  tealiumCallShopNow() {
      this.formInfoService.shopNowZeroStateLinkCall();
    }
  }
